import React from 'react';
import Communities from './Communities';

/**
 * Variante densa de /communities — dos comunidades por fila en mobile,
 * cuatro en desktop. Reusa el mismo componente con el flag dense activado;
 * cambia paddings, tamaños de avatar y stats para que las cards entren
 * cómodas en pantallas chicas.
 */
function Communities2() {
  return <Communities dense />;
}

export default Communities2;
